export const STROKE_COLORS = {
  dark: '#502f77',
  light: '#f2f0f5',
  green: '#29B966'
};